import React from 'react';
import './rem';
import Styles from './styles.css';

export default class Skeleton3 extends React.Component{
    render(){
        return (
            <div className={Styles.XyLoadingbox}>

                <p className={Styles.XyLoadingtitle750}></p>
                <p className={Styles.XyLoadingtitle550}></p>
                <p className={Styles.XyLoadinghr15}></p>

                <div style={{display:'flex'}}>
                    <p className={Styles.XyLoadingRound120}></p>
                    <div style={{flex:1,paddingTop:'0.3rem',marginLeft:'0.3rem'}}>
                        <p className={Styles.XyLoadingtxt300} style={{marginBottom:'0.2rem'}}></p>
                        <p className={Styles.XyLoadingtxt450}></p>
                    </div>
                </div>
                <p className={Styles.XyLoadinghr15}></p>

                <p className={Styles.XyLoadingimage4}></p>
                <p className={Styles.XyLoadinghr15}></p>

                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt150}></p>
                <p className={Styles.XyLoadinghr15}></p>

                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt450}></p>
                <p className={Styles.XyLoadinghr15}></p>

                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt300}></p>
                <p className={Styles.XyLoadinghr15}></p>

                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt150}></p>
                <p className={Styles.XyLoadinghr15}></p>

                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt450}></p>
                <p className={Styles.XyLoadinghr15}></p>

                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt300}></p>
                <p className={Styles.XyLoadinghr15}></p>

                <p className={Styles.XyLoadingimage4}></p>
                <p className={Styles.XyLoadinghr15}></p>

                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt150}></p>
                <p className={Styles.XyLoadinghr15}></p>

                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt450}></p>
                <p className={Styles.XyLoadinghr15}></p>

                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt300}></p>
                <p className={Styles.XyLoadinghr15}></p>

                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt150}></p>
                <p className={Styles.XyLoadinghr15}></p>

            </div>
        )
    }
}